module.exports = __webpack_public_path__ + "static/media/8_4.662fe765.png";